const loadOptions = {
  lock: true,
  text: '加载中',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.5)'
}

export default {
  loadOptions
}
